import { clone as _clone } from 'lodash';

import {
    GET_POINT_IMPORT,
    GET_POINT_TOTAL,
    GET_ACTION_TOTALS,
    GET_POINTS_IMPORTS
} from '../constants/points.js';

export const initialState = {
    imports: {},
    pointTotals: {
        ctv: null,
        text: null,
        call: null,
        volunteer: null
    },
    actionTotals: {
        ctv: null,
        text: null,
        call: null,
        volunteer: null
    },
    userPoints: null
};

export function pointsReducer( state = initialState, action ) {

    switch ( action.type ) {

        case GET_POINT_TOTAL:
            return {...state,
                userPoints: action.pointTotal
            };

        case GET_ACTION_TOTALS:
            return Object.assign( {}, state, {
                pointTotals: action.pointTotals,
                actionTotals: action.actionTotals
            });

        case GET_POINTS_IMPORTS:
            return Object.assign( {}, state, {
                imports: action.imports
            });

        case GET_POINT_IMPORT:
            let imports = _clone( state.imports );
            imports[ action.id ] = action.import;
            return Object.assign( {}, state, imports );

        default:
            return state;

    }

}



// WEBPACK FOOTER //
// ./src/reducers/points.js